<script>
import {defineComponent} from 'vue'
import {Head} from '@inertiajs/vue3'
import MobileTopBar from "@js/components/TopBar/MobileTopBar.vue"
import Breadcrumbs from "@js/components/Breadcrumbs/Breadcrumbs.vue"

import shield_svg from '@img/guarantee/shield.svg'
import star_svg from '@img/guarantee/star.svg'
import clock_svg from '@img/guarantee/clock.svg'
import money_svg from '@img/guarantee/money.svg'
import delivery_svg from '@img/guarantee/delivery.svg'
import certificate_svg from '@img/guarantee/certificate.svg'

import InfoCards from "@js/components/InfoCards/Components/InfoCards.vue"
import PartnershipLayout from "@js/Shared/PartnershipLayout.vue"
import {useCallbackStore} from "@js/store/CallbackStore.js"
import FaqComponent from "@js/components/Faq/FaqComponent.vue";

export default defineComponent({
    layout: PartnershipLayout,
    name: "B2BForJBIPage",
    components: {
        FaqComponent,
        Head,
        InfoCards,
        Breadcrumbs,
        MobileTopBar,
    },
    data() {
        return {
            // --- Преимущества для ЖБИ/бетонных заводов ---
            items_group_1: [
                {
                    logo: shield_svg,
                    title: 'ГОСТ/ТУ и контроль марок стали',
                    description: 'Арматура A500C/A240, катанка, проволока, уголок, швеллер, двутавр, лист — марочность и прокатку подтверждаем документально.',
                },
                {
                    logo: certificate_svg,
                    title: 'Паспорта качества и прослеживаемость',
                    description: 'Передаём МК/сертификаты завода. В закрывающих — номера плавок и партий для прозрачного учёта на производстве.',
                },
                {
                    logo: clock_svg,
                    title: 'Стабильные сроки и оперативные отгрузки',
                    description: 'При наличии — отгрузка день-в-день со складов Москвы и МО. Формируем календарь поставок под ваш производственный график.',
                }
            ],
            items_group_2: [
                {
                    logo: money_svg,
                    title: 'Прозрачные цены, НДС, отсрочка',
                    description: 'Счета и закрывающие с НДС, ЭДО. Спеццены на объём и регулярные закупки. Отсрочка — по договору и кредитной оценке.',
                },
                {
                    logo: delivery_svg,
                    title: 'Доставка «до ворот завода»',
                    description: 'Манипулятор/длинномер, негабарит и ж/д по запросу. Сохранность: прокладки, стяжка, маркировка мест для быстрого приёма.',
                },
                {
                    logo: star_svg,
                    title: 'Точная резка и повторяемость партий',
                    description: 'Лента/газ/плазма по картам раскроя. Соблюдаем допуски и обеспечиваем стабильность параметров от партии к партии.',
                }
            ],

            // --- FAQ (5 вопросов) ---
            faqItems: [
                {
                    question: 'Подтверждаете соответствие ГОСТ/ТУ и марку стали?',
                    answer: `<p>Да. Поставки соответствуют <strong>ГОСТ/ТУ</strong>, марочность и прокатку подтверждаем МК/паспортами качества. В документах указываем <strong>плавки и партии</strong> — удобно для входного контроля и аудита.</p>`
                },
                {
                    question: 'Выполняете резку в размер и по картам раскроя?',
                    answer: `<p>Да. Резка <strong>лентой/газом/плазмой</strong> по чертежам и картам раскроя с контролем допусков. Обеспечиваем <strong>повторяемость</strong> и маркируем позиции для ускорения складского учета.</p>`
                },
                {
                    question: 'Сроки отгрузки и варианты логистики?',
                    answer: `<p>При наличии на складе — отгрузка <strong>в день заказа</strong> по Москве и МО. Доставка <strong>манипулятором/длинномером</strong>, по запросу — <strong>ж/д и негабарит</strong>. Помогаем с пропусками и тайм-слотами.</p>`
                },
                {
                    question: 'Минимальный объём и смешанные партии?',
                    answer: `<p>Ориентир — от <strong>5 тонн</strong>. Смешанные спецификации (арматура, катанка, проволока, уголок, швеллер, двутавр, лист) комплектуем под производственную ведомость. Мелкие <strong>дозаказы</strong> согласуем индивидуально.</p>`
                },
                {
                    question: 'Как формируются цены? Есть НДС, ЭДО и фиксация?',
                    answer: `<p>Цены в RUB с <strong>НДС</strong>, работаем через <strong>ЭДО</strong>. По заявке <strong>фиксируем цену</strong> на 1–3 дня или на согласованный срок под ваш план поставок; возможна <strong>отсрочка</strong> по договору.</p>`
                },
            ],
        }
    },
    methods: {
        openForm(title = 'Запросить коммерческое предложение', bitrix = 'Заявка B2B (ЖБИ/бетон)') {
            this.callbackStore.showBaseCallbackPopup({
                title,
                bitrix_title: bitrix,
            })
        }
    },
    setup() {
        const callbackStore = useCallbackStore()
        return {callbackStore}
    }
})
</script>

<template>
    <div>
        <div class="bg-black pt-5 md:pt-10 pb-[150px] text-white">
            <div class="container">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
                    <div class="flex items-center justify-center">
                        <div>
                            <Breadcrumbs class="text-white" color="#ffcf33"/>
                            <h1 class="text-2xl md:text-4xl font-bold mb-5 mt-5">
                                B2B-решения для заводов ЖБИ и бетонных заводов
                            </h1>
                            <p class="md:text-xl mb-5 md:max-w-[80%]">
                                Поставки арматуры A500C/A240, катанки, проволоки, уголка, швеллера, двутавра и листового проката.
                                Резка в размер, комплектовка по спецификациям, отгрузка день-в-день и доставка «до ворот». НДС/ЭДО, отсрочка по договору.
                            </p>
                            <button
                                @click.prevent="openForm()"
                                class="flex max-md:w-full justify-center items-center text-black md:hover:text-baseYellow border-2 border-baseYellow bg-baseYellow md:hover:bg-transparent font-bold rounded-lg text-sm px-14 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                            >
                                Запросить КП
                            </button>
                        </div>
                    </div>
                    <div class="flex items-center justify-center max-md:hidden">
                        <img
                            src="@img/b2b/jbi/top-bg.webp"
                            class="max-h-[500px] rounded-full aspect-square object-cover"
                            alt="B2B поставки металлопроката для заводов ЖБИ и бетонных заводов"
                            title="Оптовые поставки металлопроката для ЖБИ и бетонных заводов"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-white rounded-t-[25px] md:rounded-t-[50px] -mt-[100px] md:mb-20">
            <div class="container pt-10 md:pt-20 mb-5 md:mb-20">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-10">
                    <!-- ЖБИ -->
                    <div class="flex flex-col border rounded-2xl p-5 md:p-7 bg-[url('@img/b2b/jbi/block1.webp')] bg-cover shadow-xl">
                        <h2 class="text-white text-2xl md:text-3xl font-bold mb-5">
                            Услуги для производителей ЖБИ
                        </h2>
                        <div class="grid grid-cols-2 gap-3 md:gap-5 h-full">
                            <div class="flex flex-col md:items-center justify-center text-white bg-gray-500/40 backdrop-blur-sm p-4 rounded-lg md:rounded-2xl font-medium md:text-center text-sm md:text-base">
                                <p>Резка арматуры и профильного проката</p>
                            </div>
                            <div class="flex flex-col md:items-center justify-center text-white bg-gray-500/40 backdrop-blur-sm p-4 rounded-lg md:rounded-2xl font-medium md:text-center text-sm md:text-base">
                                <p>Комплектовка по производственным спецификациям</p>
                            </div>
                            <div class="flex flex-col md:items-center justify-center text-white bg-gray-500/40 backdrop-blur-sm p-4 rounded-lg md:rounded-2xl font-medium md:text-center text-sm md:text-base">
                                <p>Отгрузка со склада день-в-день</p>
                            </div>
                            <div class="flex flex-col md:items-center justify-center text-white bg-gray-500/40 backdrop-blur-sm p-4 rounded-lg md:rounded-2xl font-medium md:text-center text-sm md:text-base">
                                <p>Логистика: манипулятор, длинномер, ж/д</p>
                            </div>
                            <div class="flex flex-col md:items-center justify-center text-white bg-gray-500/40 backdrop-blur-sm p-4 rounded-lg md:rounded-2xl font-medium md:text-center text-sm md:text-base">
                                <p>Документы с НДС, ЭДО, возможна отсрочка</p>
                            </div>
                            <div class="flex flex-col md:items-center justify-center text-white bg-gray-500/40 backdrop-blur-sm p-4 rounded-lg md:rounded-2xl font-medium md:text-center text-sm md:text-base">
                                <p>Прослеживаемость: партии, плавки, маркировка мест</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col border rounded-2xl p-5 md:p-7 bg-[url('@img/b2b/jbi/block2.webp')] bg-cover shadow-xl">
                        <h2 class="text-white text-2xl md:text-3xl font-bold mb-5">
                            Услуги для бетонных заводов
                        </h2>
                        <div class="grid grid-cols-2 gap-3 md:gap-5 h-full">
                            <div class="flex flex-col md:items-center justify-center text-white bg-gray-500/40 backdrop-blur-sm p-4 rounded-lg md:rounded-2xl font-medium md:text-center text-sm md:text-base">
                                <p>Поставки партиями</p><p>от 5 т и выше</p>
                            </div>
                            <div class="flex flex-col md:items-center justify-center text-white bg-gray-500/40 backdrop-blur-sm p-4 rounded-lg md:rounded-2xl font-medium md:text-center text-sm md:text-base">
                                <p>Согласование графика под смены и отгрузки</p>
                            </div>
                            <div class="flex flex-col md:items-center justify-center text-white bg-gray-500/40 backdrop-blur-sm p-4 rounded-lg md:rounded-2xl font-medium md:text-center text-sm md:text-base">
                                <p>Отгрузка со склада день-в-день</p>
                            </div>
                            <div class="flex flex-col md:items-center justify-center text-white bg-gray-500/40 backdrop-blur-sm p-4 rounded-lg md:rounded-2xl font-medium md:text-center text-sm md:text-base">
                                <p>Проверенные перевозчики и негабарит</p>
                            </div>
                            <div class="flex flex-col md:items-center justify-center text-white bg-gray-500/40 backdrop-blur-sm p-4 rounded-lg md:rounded-2xl font-medium md:text-center text-sm md:text-base">
                                <p>Полный пакет документов с НДС</p>
                            </div>
                            <div class="flex flex-col md:items-center justify-center text-white bg-gray-500/40 backdrop-blur-sm p-4 rounded-lg md:rounded-2xl font-medium md:text-center text-sm md:text-base">
                                <p>Персональный менеджер и SLA по срокам</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <InfoCards :items_group_1="items_group_1" :items_group_2="items_group_2" class="mb-5 md:mb-20"/>
        <div class="container">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5 md:mb-20">
                <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                    <h2 class="text-2xl md:text-3xl font-bold mb-5">
                        Снимаем рутину снабжения у производств
                    </h2>
                    <p class="mb-3">
                        Берём на себя подбор по ГОСТ/ТУ, точную резку, комплектовку и логистику — чтобы линия и формовочные посты работали без простоев.
                    </p>
                    <p class="mb-3">
                        Учитываем требования входного контроля, безопасность разгрузки и правила складирования металлопроката.
                    </p>
                    <p class="mb-3">Закрываем задачи:</p>
                    <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                        <li>подбор профилей и марок стали под нагрузки и регламенты;</li>
                        <li>резка по картам/чертежам с контролем допусков;</li>
                        <li>комплектовка, маркировка мест и упаковочные листы;</li>
                        <li>логистика «до ворот» или на площадку, погрузка-разгрузка.</li>
                    </ul>
                </div>
                <div class="bg-grayBg p-5 md:p-10 rounded-lg md:rounded-2xl">
                    <h2 class="text-2xl md:text-3xl font-bold mb-5">
                        Как начать сотрудничество
                    </h2>
                    <p class="mb-3">
                        Оставьте заявку — подготовим КП под объёмы, график поставок и требования к упаковке/маркировке. Закрепим менеджера и согласуем SLA по срокам.
                    </p>
                    <ul class="list-disc list-outside space-y-3 ps-5 font-medium">
                        <li>спеццены на крупные партии и регулярные закупки;</li>
                        <li>личный кабинет: онлайн-заказы и статусы отгрузок;</li>
                        <li>полный комплект документов с НДС, ЭДО, возможна отсрочка.</li>
                    </ul>
                    <button
                        @click.prevent="openForm('Оставить заявку на КП', 'Заявка на КП (ЖБИ/бетон)')"
                        class="mt-4 flex justify-center items-center text-white md:hover:text-baseColor border-2 border-baseColor bg-baseColor md:hover:bg-transparent font-bold rounded-lg text-sm px-6 py-2.5 focus:outline-none transition cursor-pointer uppercase"
                    >
                        Оставить заявку
                    </button>
                </div>
            </div>
        </div>
        <section class="container">
            <FaqComponent
                title="FAQ по сотрудничеству"
                subtitle="Ассортимент, резка и комплектовка, логистика, НДС/ЭДО, отсрочка и фиксация цены — собрали ответы на ключевые вопросы."
                :items="faqItems"
                schema-id="schema-b2b-faq-jsonld"
            />
        </section>
    </div>
</template>

<style scoped lang="scss">
</style>
